import React, { createContext, useCallback, useContext, useEffect, useState, ReactNode } from 'react';

interface DiningContextType {
  enableDining: boolean;
  toggleDining: () => void;
  setEnableDining: (value: boolean) => void;
}

const DiningContext = createContext<DiningContextType | undefined>(undefined);

// Aligned with mobile Redux User.enableDinning / toggleDinning
export const DiningProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [enableDining, setEnableDiningState] = useState<boolean>(() => {
    return localStorage.getItem('enableDining') === 'true';
  });

  useEffect(() => {
    localStorage.setItem('enableDining', String(enableDining));
  }, [enableDining]);

  const setEnableDining = useCallback((value: boolean) => {
    setEnableDiningState(value);
  }, []);

  const toggleDining = useCallback(() => {
    setEnableDiningState((prev) => !prev);
  }, []);

  return (
    <DiningContext.Provider value={{ enableDining, toggleDining, setEnableDining }}>
      {children}
    </DiningContext.Provider>
  );
};

export const useDining = () => {
  const context = useContext(DiningContext);
  if (!context) {
    throw new Error('useDining must be used within a DiningProvider');
  }
  return context;
};
